jQuery(document).ready(function($) {
    jQuery(document).ajaxComplete(function() {
        if(window.inquiryWaiter) {
            clearTimeout(window.inquiryWaiter);
        }
        window.inquiryWaiter = setTimeout(function() {
            $('.inquiry-wrapper').each(function() {
                const wrapper = $(this);
                wrapper.find(':input').unbind('keyup.inquiry, change.inquiry').bind('keyup.inquiry, change.inquiry', function() {
                    wrapper.find('[data-if]').each(function() {
                        const toggleItem = $(this);
                        const ifExpressions = toggleItem.attr('data-if').split('|');
                        let show = false;
                        let found = false;
                        for(let i in ifExpressions) {
                            const ifExpression = ifExpressions[i];

                            const key = ifExpression.split(':')[0];
                            const input = wrapper.find(`:input[name="${key}"]`);
                            if (input.length > 0) {
                                found = true;
                                let desiredValue = ifExpression.split(':')[1];
                                let not = false;
                                if (desiredValue.substr(0,1) === '!') {
                                    not = true;
                                    desiredValue = desiredValue.substr(1);
                                }

                                const isBool = input.is('[type="checkbox"]');
                                const isRadio = input.is('[type=radio]');
                                let value = isBool ? input.is(':checked') : input.val();
                                if (isRadio) {
                                    value = wrapper.find(`:input[name="${key}"]:checked`).val();
                                }

                                if (isBool) {
                                    show = (desiredValue === 'true') === value;
                                } else {
                                    show = desiredValue === value;
                                }
                                if (not) {
                                    show = !show;
                                }

                                toggleItem.toggle(show);
                                if (show) {
                                    return;
                                }
                            }
                        }
                        if (!found) {
                            toggleItem.toggle(false);
                        }
                    });
                });
                wrapper.find(':input').trigger('change.inquiry');
            });
        },100);
    });
});
